import axios from 'axios';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

const useCompleteScoringProjectModule = () => {
  const { mutate, isLoading } = useMutation(async ({ projectId, module }) => {
    return await axios.post(`/standardization/${projectId}/modules/${module.id}/complete`, module);
  });

  const completeModuleScoring = (module, projectId, options) => {
    mutate(
      { projectId, module },
      {
        onSuccess: () => {
          options?.onSuccess && options.onSuccess(module.id);
          toast.success('Successfully marked the scoring of the module as completed!');
        },
      }
    );
  };

  return {
    completeModuleScoring,
    isLoading,
  };
};

export default useCompleteScoringProjectModule;
